<template>
  <div>
    <!--- 委托项目 -->
    <div v-if="projectId" class="card">
      <entrust-info-dialog
        v-model="projectId"
        :read-only="true"
        :entrust-info="entrustProjectInfo"
      />
    </div>

    <!--- 询比单信息 -->
    <div v-for="item in optionList" :key="item.title" class="card">
      <div class="section">
        <div v-if="!item.hideTitle" class="section-title">
          <base-section-title :title="item.title" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            v-if="item.componentName === 'descriptions'"
            :info="order"
            :option="item.option"
            :el-attrs="{
              size: 'medium',
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:supplierCategoryList>
              <div v-if="supplierCategoryList.length">
                <select-group-supplier
                  v-model="supplierCategoryList"
                  :normalize-in="normalizeInGroup"
                  :read-only="true"
                />
              </div>
              <span v-else>-</span>
            </template>
            <!-- 线上评审文件 -->
            <template v-slot:reviewWayList>
              <el-button
                type="text"
                style="padding: 2px"
                @click="jumpInquiryReviewInfo()"
              >
                查看详情
              </el-button>
            </template>
            <template v-slot:fee="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }} 元</span>
              <money-in-cn :money="value" class="m-l-10" />
            </template>
            <template v-slot:serviceFee>
              <el-button
                v-if="serviceInfo.chargeType === chargeTypeDict.CHARGE.value"
                type="text"
                style="padding: 0"
                @click="openConfigDialog()"
              >
                费用计算公式
              </el-button>
              <div
                v-else-if="serviceInfo.chargeType === chargeTypeDict.FREE.value"
              >
                <span>0 元</span>
                <money-in-cn money="0" />
              </div>
              <div v-else>-</div>
            </template>
            <!--控制总价-->
            <template v-slot:controlPrice="{ value }">
              <span>{{ strToThousands(value.controlPrice) }}</span>
              <span class="m-l-4">
                {{ currencyTypeDict.translate(value.currencyType).label }}
              </span>
              <money-in-cn
                v-if="
                  value.currencyType === currencyTypeDict.YUAN.value &&
                    value.controlPrice
                "
                class="m-l-10"
                :money="value.controlPrice"
              />
            </template>
            <template slot="inviteList">
              <div class="tag-wrapper">
                <el-tag
                  v-for="tag in inviteList"
                  :key="tag.inviteId"
                  class="m-r-6 m-b-4"
                  type="primary"
                  size="small"
                >
                  {{ tag.supplierName }}
                </el-tag>
              </div>
            </template>
            <template slot="inviteAddList">
              <div class="tag-wrapper">
                <el-tag
                  v-for="tag in inviteAddList"
                  :key="tag.inviteId"
                  type="primary"
                  size="small"
                >
                  {{ tag.supplierName }}
                </el-tag>
              </div>
            </template>
            <template v-slot:otherRequire="{ value }">
              <other-material-requirements :table="value || []" mode="detail" />
            </template>

            <!-- 五菱内部附件/非五菱内部文件 -->
            <template v-slot:internalAttachmentIds="{ value }">
              <upload
                v-if="value.internalAttachmentIds"
                :file-id-before="value.internalAttachmentIds"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId'
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>

          <template v-if="item.componentName === 'materialTable'">
            <material-table
              v-if="isTableGreyFeatures"
              :is-wuling="true"
              :can-edit="false"
              :is-dollar="order.currencyType === currencyTypeDict.DOLLAR.value"
              :table-data="materialList"
              :require-tax="requireTax"
            />
            <purchase-list
              v-else
              ref="purchaseList"
              :table-data="materialList"
              :is-dollar="order.currencyType === currencyTypeDict.DOLLAR.value"
              :item-schema-list="itemSchemaList"
              :purchase-type="materialTemplateBelongDict.INQUIRY.value"
              read-only
            />
          </template>

          <template v-if="item.componentName === 'inquiryFile'">
            <el-form label-width="85px" label-suffix="：" class="m-t-8">
              <el-form-item :label="item.title">
                <InquiryFile
                  v-if="order.inquiryFileGroupId"
                  v-model="order.inquiryFileGroupId"
                  :order-id="orderId"
                  :read-only="true"
                  :is-release="true"
                />
                <span v-else>-</span>
              </el-form-item>
            </el-form>
          </template>
        </div>
      </div>
    </div>

    <!---备注说明---->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="备注说明" />
        </div>
        <div class="section-content">
          <p>{{ order.remarks || '-' }}</p>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="所有公告" />
        </div>
        <div class="section-content">
          <bulletin-item
            v-if="purchaseNotice.noticeTitle"
            :bulletin-label="publicInquiry ? '采购公告' : '邀请函'"
            :title="purchaseNotice.noticeTitle"
            :content="purchaseNotice.noticeContent"
            :release-time="purchaseNotice.noticePublishTime"
            :button-text="publicInquiry ? '查看公告' : '查看邀请函'"
            :hide-status="false"
            :release-status-obj="
              noticeReleaseStatusDict.translate(
                purchaseNotice.noticeReleaseStatus
              )
            "
            :is-time-norm-day="true"
          />
          <template v-if="changeNoticeList.length">
            <bulletinItem
              v-for="item in changeNoticeList"
              :key="item.noticeId"
              bulletin-label="变更公告"
              :title="item.noticeTitle"
              :content="item.noticeContent"
              :release-time="item.noticePublishTime"
              :hide-status="false"
              :release-status-obj="
                noticeReleaseStatusDict.translate(item.noticeReleaseStatus)
              "
              :is-time-norm-day="true"
            />
          </template>
          <bulletin-item
            v-if="closeNotice.noticeTitle"
            bulletin-label="流标公告"
            :title="closeNotice.noticeTitle"
            :content="closeNotice.noticeContent"
            :release-time="closeNotice.noticePublishTime"
            :hide-status="false"
            :release-status-obj="
              noticeReleaseStatusDict.translate(closeNotice.noticeReleaseStatus)
            "
            :is-time-norm-day="true"
          />
        </div>
      </div>
    </div>

    <!----澄清文件----->
    <div v-if="attachmentList.length" class="card">
      <clarification-file
        :attachment-list="attachmentList"
        :order-id="orderId"
        :preview-api="previewPurchaseInquiryFileApi"
        :download-api="downloadPurchaseInquiryFileApi"
      />
    </div>

    <!----计算公式详情--->
    <charge-config-dialog
      ref="chargeConfigDialog"
      :config-obj="{
        configId: serviceInfo.configId,
        templateId: serviceInfo.templateId
      }"
    />

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      class="m-t-16"
      :remark-list="remarkList"
    />

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="orderInfo.flowListing"
    />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import MaterialTable from '@/components/inquiry/material/MaterialTable'
import BulletinItem from '@/components/common/Bulletins/BulletinItem'
import EntrustInfoDialog from '@/components/entrust/EntrustInfoDialog'
import ClarificationFile from '@/components/common/ClarificationFile'
import SelectGroupSupplier from '@/components/common/SelectSupplierDrawer/SelectGroupSupplier.vue'
import InquiryFile from '@/components/inquiry/InquiryFile'
import MoneyInCn from '@/components/common/MoneyInCn'
import OtherMaterialRequirements from '@/components/common/OtherMaterialRequirements/OtherMaterialRequirements'
import ChargeConfigDialog from '@/components/common/ChargeConfigDialog'
import PurchaseList from '@/components/common/PurchaseListComponent/PurchaseList'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'
import Upload from '@/components/common/Upload/index'

// 数据字典
import {
  projectOpenScopeDict,
  projectTypeDict,
  releaseMediaDict,
  whetherDict,
  whetherSignatureDict,
  noticeReleaseStatusDict,
  announcementTypeDict,
  currencyTypeDict,
  isSignupShowListingDict,
  projectAssetDisposalMethodDict,
  offerTypeDict
} from '@/dictionary/project/common'
import { costSubjectDict, chargeTypeDict } from '@/dictionary/company'
import {
  inquiryAllowPartDict,
  inquiryCompareWayDict,
  inquiryInviteTypeDict,
  inquiryNeedReviewDict,
  inquiryProcureTypeDict,
  inquiryRequireTaxDict,
  inquiryWayDict,
  inquiryOfferFileDict,
  inquiryReviewModelDict
} from '@/dictionary/project/inquiry'
// 接口
import {
  getInquiryOrderApi,
  previewPurchaseInquiryFileApi,
  downloadPurchaseInquiryFileApi,
  getSupplementListApi,
  getInquiryPublishNoticeApi
} from '@/api/procure/inquiry'
// 工具方法
import DateUtils from '@/utils/date'
import { strToThousands } from '@/utils/utils'
import { materialTemplateBelongDict } from '@/dictionary/material/template'
import { workbenchServiceDict } from '@/dictionary/system'

import { mapState } from 'vuex'
import { mapActions } from 'vuex'
import { getPurchaseReviewDetailApi } from '@/api/procure/purchase-review'
export default {
  name: 'InquiryOrderInfo',

  components: {
    BaseSectionTitle,
    MaterialTable,
    BulletinItem,
    EntrustInfoDialog,
    ClarificationFile,
    SelectGroupSupplier,
    InquiryFile,
    MoneyInCn,
    OtherMaterialRequirements,
    ChargeConfigDialog,
    PurchaseList,
    RecordHistory,
    RecordRemark,
    Upload
  },

  props: {
    requestQuery: {
      type: Object,
      default: () => {}
    },

    isByOrderId: {
      type: Boolean,
      default: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    },

    isWuling: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      orderInfo: {},
      optionList: [],

      attachmentList: [],

      isTableGreyFeatures: false,

      chargeTypeDict,
      noticeReleaseStatusDict,
      materialTemplateBelongDict,
      currencyTypeDict,
      inquiryReviewModelDict,

      previewPurchaseInquiryFileApi,
      downloadPurchaseInquiryFileApi,

      purchaseNotice: {}, // 采购公告信息
      changeNoticeList: [], // 变更公告列表
      closeNotice: {}, // 流标公告信息
      // 线上评审办法列表
      reviewList: [],
      reviewId: 0
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    orderId() {
      return this.requestQuery.orderId || 0
    },

    projectId() {
      return this.entrustProjectInfo.projectId || 0
    },

    order() {
      return this.orderInfo.order || {}
    },

    serviceInfo() {
      const obj =
        (this.orderInfo.chargeList || []).find(
          m => m.costSubject === costSubjectDict.SERVICE_FEE.value
        ) || {}
      return obj
    },

    // 询比方式是否为公开询比
    publicInquiry() {
      return this.order.inquiryType === inquiryWayDict.PUBLIC_INQUIRY.value
    },

    // 是否需要报名审核
    needSignCheck() {
      return this.order.checkType === whetherDict.YES.value
    },

    // 品目列表
    materialList() {
      return this.orderInfo.materielList || []
    },

    // 品目字段列配置
    itemSchemaList() {
      return this.orderInfo.itemSchemaList || []
    },

    // 是否含有变更公告
    haveChangeNotice() {
      return (
        this.orderInfo.changeNoticeList &&
        this.orderInfo.changeNoticeList.length > 0
      )
    },

    // 是否有流标公告
    haveCloseNotice() {
      return this.orderInfo.closeNotice
    },

    // 邀请供应商列表
    inviteList() {
      return (
        (this.orderInfo.inviteList || []).filter(
          item => item.inviteType == inquiryInviteTypeDict.ORIGIN.value
        ) || []
      )
    },

    // 追加的邀请供应商列表
    inviteAddList() {
      return (
        (this.orderInfo.inviteList || []).filter(
          item => item.inviteType == inquiryInviteTypeDict.ADD.value
        ) || []
      )
    },

    // 已选公开范围
    supplierCategoryList() {
      return this.orderInfo.orderSupplierCategoryList || []
    },

    // 委托项目信息
    entrustProjectInfo() {
      return this.orderInfo.entrustProjectInfo || {}
    },

    // 是否含税
    requireTax() {
      return this.order.offerRequireTax === inquiryRequireTaxDict.YES.value
    },

    /**
     * 平台使用费是否不收费
     */
    isSignUpFeeFree() {
      const tempObj =
        (this.orderInfo.chargeList || []).find(
          el => el.costSubject == costSubjectDict.REGISTER_FEE.value
        ) || {}
      return tempObj?.chargeType === chargeTypeDict.FREE.value
    },

    /**
     * 保证金是否不收费
     */
    isGuaranteeFeeFree() {
      const tempObj =
        (this.orderInfo.chargeList || []).find(
          el => el.costSubject == costSubjectDict.BOND.value
        ) || {}
      return tempObj?.chargeType === chargeTypeDict.FREE.value
    },

    /**
     * 服务费是否不收费
     */
    isServiceFeeFree() {
      return this.serviceInfo?.chargeType === chargeTypeDict.FREE.value
    },

    /**
     * 是否是线上评审
     */
    isOnlineReview() {
      return !!this.orderInfo?.order?.isReview
    },

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val?.orderId) {
          this.orderInfo = this.requestQuery.orderInfo
          this.getOptionList()
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        if (this.isByOrderId && val) {
          this.getOrderInfo()
        }
        this.getSupplementList()
        this.getAllNotice()
      },
      immediate: true
    },

    isWuling(val) {
      this.isTableGreyFeatures = val
    }
  },

  // async created() {
  //   this.isTableGreyFeatures = await this.showGreyFeature({
  //     code: 'inquiry-table'
  //   })
  // },

  methods: {
    ...mapActions('company', ['showGreyFeature']),

    strToThousands,

    /**
     * 获取澄清文件列表
     */
    async getSupplementList() {
      try {
        const _data = await getSupplementListApi(this.orderId)
        this.attachmentList = _data.data || []
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 获取询比单信息
     */
    getOrderInfo() {
      getInquiryOrderApi({ orderId: this.orderId })
        .then(res => {
          this.orderInfo = res?.data || {}
          this.isTableGreyFeatures = Boolean(res?.data?.order?.isWuling)
          this.getOptionList()
          this.getPurchaseReviewOrder(this.orderInfo?.order?.reviewId)
        })
        .catch(err => {
          console.error('获取询比单信息失败', err)
          this.$message.error(err.message || '获取询比单信息')
        })
    },

    /**
     * @description: 获取所有公告列表
     * @param {*}
     * @return {*}
     */
    async getAllNotice() {
      try {
        const _data = await getInquiryPublishNoticeApi(this.orderId)
        const data = _data.data || []

        const _purchaseInfo = data.filter(
          el => el.noticeType === announcementTypeDict.PURCHASE.value
        )
        this.purchaseNotice = _purchaseInfo.length ? _purchaseInfo[0] : {}

        this.changeNoticeList = data.filter(
          el => el.noticeType === announcementTypeDict.CHANGE.value
        )

        const _abnormalInfo = data.filter(
          el => el.noticeType === announcementTypeDict.FLOW.value
        )
        this.closeNotice = _abnormalInfo.length ? _abnormalInfo[0] : {}
      } catch (error) {
        this.$message.error(error.message || '获取公告信息失败')
      }
    },

    /**
     * 定向公开范围供应商输入字段转换
     */
    normalizeInGroup(list) {
      return list.map(tag => {
        return {
          categoryType: tag.categoryType,
          categoryId: tag.srmCategoryId,
          name: tag.srmCategoryName
        }
      })
    },

    /**
     * 打开平台服务费配置
     */
    openConfigDialog() {
      this.$refs.chargeConfigDialog.open()
    },

    // 查看线上评审文件
    jumpInquiryReviewInfo() {
      const routeParams = this.$route.params
      this.$router.push({
        name: this.entrustRouter + 'InquiryOnlineReviewFile',
        params: routeParams,
        query: {
          reviewId: this.orderInfo.order.reviewId
        }
      })
    },

    /**
     * 获取页面配置列表
     */
    getOptionList() {
      this.optionList = [
        {
          title: '询比单信息',
          componentName: 'descriptions',
          option: [
            {
              label: '询比单名称',
              prop: 'orderName',
              elAttrs: {
                span: 3
              }
            },
            {
              label: '询比单编号',
              prop: 'orderCode'
            },
            {
              label: '项目类型',
              prop: 'projectType',
              filter: value => projectTypeDict.translate(value).label || ' - '
            },
            {
              label: '报价方式',
              prop: 'offerType',
              filter: value => offerTypeDict.translate(value).label || ' - '
            },
            {
              label: '处置方式',
              prop: 'assetDisposalMethod',
              filter: value =>
                projectAssetDisposalMethodDict.translate(value)?.label ||
                projectAssetDisposalMethodDict.EXPENDITURE.label,
              hideFun: () =>
                this.order.projectType !== projectTypeDict.ASSET_DISPOSAL.value
            },
            {
              label: '收货地址',
              prop: 'address',
              filter: value => {
                if (value?.receivingCountry === '中国') {
                  return value?.receivingProvince
                    ? `${value?.receivingProvince} ${value?.receivingCity} ${value?.receivingArea}`
                    : ' - '
                } else {
                  return value?.receivingCountry
                }
              }
            },
            {
              label: '详细地址',
              prop: 'address.address'
            },
            {
              label: '发布媒体',
              prop: 'noticeMedium',
              filter: value => {
                const temp = (value || '').split(',')
                return (
                  temp
                    .map(mediumValue => {
                      return releaseMediaDict.translate(mediumValue)?.label
                    })
                    .filter(value => value)
                    .join('、') || '-'
                )
              }
            }
          ]
        },
        {
          title: '供应商签章设置',
          componentName: 'descriptions',
          hide: this.isTableGreyFeatures,
          option: [
            {
              label: '报价单是否在线签章',
              prop: 'quotationElectronicSignature',
              filter: value => whetherSignatureDict.translate(value).label
            },
            {
              label: '报价附件是否在线签章',
              prop: 'quotationAccessoryElectronicSignature',
              filter: value => whetherSignatureDict.translate(value).label
            }
          ]
        },
        {
          title: '对供应商要求',
          componentName: 'descriptions',
          option: [
            {
              label: '报价截止时间',
              prop: 'offerEndTime',
              filter: value => DateUtils.format(value, 'yyyy年MM月dd日 HH:mm')
            },
            {
              label: '采购类型',
              prop: 'purchaseType',
              filter: value =>
                inquiryProcureTypeDict.translate(value).label || ' - '
            },
            {
              label: '平台使用费',
              prop: 'signUpFee',
              slotName: 'fee',
              hideFun: () => this.isTableGreyFeatures && this.isSignUpFeeFree
            },
            {
              label: '保证金',
              prop: 'guaranteeFee',
              slotName: 'fee',
              hideFun: () => this.isTableGreyFeatures && this.isGuaranteeFeeFree
            },
            {
              label: '报价含税',
              prop: 'offerRequireTax',
              filter: value =>
                inquiryRequireTaxDict.translate(value).label || '-'
            },
            {
              label: '允许对部分品目报价',
              prop: 'offerAllowPart',
              filter: value =>
                inquiryAllowPartDict.translate(value).label || '-'
            },
            {
              label: '平台服务费',
              slotName: 'serviceFee',
              hideFun: () => this.isTableGreyFeatures && this.isServiceFeeFree
            },
            {
              label: '报价币种',
              prop: 'currencyType',
              filter: value => currencyTypeDict.translate(value).name || '-'
            },
            {
              label: '汇率（美元兑人民币）',
              prop: 'exchangeRate',
              hideFun: () =>
                this.order.currencyType !== currencyTypeDict.DOLLAR.value
            },
            {
              label: '控制总价',
              prop: '',
              filter: value => {
                return {
                  currencyType: value.currencyType,
                  controlPrice: value.controlPrice
                }
              },
              hideFun: () => this.order.isControlPrice === whetherDict.NO.value,
              slotName: 'controlPrice'
            },
            {
              label: '是否必须上传报价附件',
              prop: 'isNeedOfferFile',
              filter: value =>
                inquiryOfferFileDict.translate(value)?.label || '-',
              hideFun: () => this.isTableGreyFeatures
            },
            {
              label: '评审办法',
              prop: 'reviewModel',
              filter: value => inquiryReviewModelDict.translate(value).label || '-'
            },
            {
              label: '是否需线上评审',
              prop: 'isReview',
              filter: value => (value ? '是' : '否')
            },
            {
              label: '线上评审文件',
              prop: '',
              slotName: 'reviewWayList',
              hideFun: () => !this.order.isReview
            }
          ]
        },
        {
          title: '品目信息',
          componentName: 'materialTable'
        }
      ].filter(v => !v.hide)

      if (this.isTableGreyFeatures) {
        this.optionList.push({
          title: '内部附件上传',
          componentName: 'descriptions',
          option: [
            {
              label: '内部附件',
              slotName: 'internalAttachmentIds'
            }
          ]
        })
      }

      const inquiryMethodOption = {
        title: '询比方式',
        componentName: 'descriptions',
        column: this.optionColumn,
        option: [
          {
            label: '询比方式',
            prop: 'inquiryType',
            filter: value => inquiryWayDict.translate(value).label || '-'
          }
        ]
      }
      inquiryMethodOption.option.push({
        label: '比价方式',
        prop: 'compareType',
        filter: value => inquiryCompareWayDict.translate(value).label || ' - '
      })
      if (this.publicInquiry) {
        inquiryMethodOption.option = inquiryMethodOption.option.concat([
          {
            label: '公开范围',
            prop: 'openScope',
            filter: value => projectOpenScopeDict.translate(value).label || '-'
          },
          {
            label: '已选公开范围',
            slotName: 'supplierCategoryList',
            elAttrs: {
              span: 2
            },
            hideFun: () =>
              this.order.openScope !== projectOpenScopeDict.COMPANY.value
          },
          {
            label: '报价时段查看供应商参与名单',
            prop: 'isSignupShowListing',
            filter: value =>
              isSignupShowListingDict.translate(value).label || '-'
          },
          {
            label: '报名审核',
            prop: 'checkType',
            filter: value => inquiryNeedReviewDict.translate(value).label || '-'
          }
        ])
        if (this.needSignCheck) {
          inquiryMethodOption.option = inquiryMethodOption.option.concat([
            {
              label: '证件要求',
              prop: 'requireList',
              filter: value => {
                const certNameArray = value?.map(item => item.certName)
                return certNameArray?.length > 0
                  ? certNameArray?.join('，')
                  : '-'
              }
            },
            {
              label: '其他材料要求',
              prop: 'otherMaterialList',
              slotName: 'otherRequire'
            },
            {
              label: '备注说明',
              prop: 'checkRemarks'
            }
          ])
        }
      } else {
        inquiryMethodOption.option = inquiryMethodOption.option.concat([
          {
            label: '邀请供应商',
            slotName: 'inviteList',
            hideFun: data =>
              data.inquiryType !== inquiryWayDict.INVITE_INQUIRY.value
          },
          {
            label: '追加供应商',
            slotName: 'inviteAddList',
            hideFun: () => !this.inviteAddList.length
          }
        ])
      }

      if (!this.isTableGreyFeatures) {
        inquiryMethodOption.option.push({
          label: '内部文件',
          slotName: 'internalAttachmentIds',
          elAttrs: { span: 3 }
        })
      }

      this.optionList.push(inquiryMethodOption)
      const inquiryFileOption = {
        title: '询比文件',
        componentName: 'inquiryFile'
      }
      this.optionList.push(inquiryFileOption)
    },

    /**
     * 查询线上评审单
     */
    getPurchaseReviewOrder(reviewId) {
      if (!reviewId) return
      getPurchaseReviewDetailApi(reviewId).then(res => {
        const _data = res.data || {}
        this.reviewList = _data.wayInfoList || []
        this.reviewId = _data.reviewId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  ::v-deep .el-descriptions-item__label {
    flex-shrink: 0 !important;
  }
}
</style>
